<template>
  <b-overlay
    :show="show"
    :variant="variant"
    :opacity="opacity"
    :blur="blur"
    rounded="lg"
    spinner-variant="primary"
  >
   <b-card v-if="recordNotFound">
      <b>{{$t("NoRecordFound")}}</b>
      <router-link :to="'/company/department'" class="float-right">
          <b-button variant="primary" class="primary">{{
            $t("Back")
          }}</b-button>
        </router-link>
    </b-card>
    <b-card id="department-form" v-else>
      <h1 v-if="this.$route.params.id">{{ $t("EditDepartment") }}</h1>
      <h1 v-else>{{ $t("AddDepartment") }}</h1>
      <div v-if="this.$route.params.id && directUrl.length" class="direct w-full">
        <span class="url">{{ directUrl + departments.slug }}</span>
        <feather-icon
          id="copy"
          v-b-tooltip.hover
          :title="$t('Copy')"
          icon="CopyIcon"
          svgClasses="w-4 h-4 hover:text-danger stroke-current"
          class="ml-2"
          @click="copyCode(directUrl + departments.slug)"
        />
      </div>
      <form method="post" v-on:submit.prevent="$event.preventDefault()">
        <div class="vx-row">
          <div class="vx-col md:w-full w-full">
            <label class="vs-input--label"
              >{{ $t("DepartmentName") }} <span class="red">*</span></label
            >
            <b-input
              size="lg"
              v-validate="{ required: true }"
              autocomplete="off"
              name="department_name"
              :data-vv-as="$t('DepartmentName')"
              v-model="departments.department_name"
              @input="changeSlug(departments.department_name)"
              class="w-full"
              @keydown.enter="checkForm"
              :placeholder="$t('DepartmentName')"
            />
            <span class="text-danger text-sm" v-show="errors.has('department_name')">{{
              errors.first("department_name")
            }}</span>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col md:w-full w-full">
            <label class="vs-input--label"
              >{{ $t("DepartmentSlug") }} <span class="red">*</span></label
            >
            <b-input
              size="lg"
              v-validate="{ required: true }"
              name="slug"
              :data-vv-as="$t('DepartmentSlug')"
              v-model="departments.slug"
              @input="editSlug(departments.slug)"
              class="w-full"
              :placeholder="$t('DepartmentSlug')"
            />
            <span class="text-danger text-sm" v-show="errors.has('slug')">{{
              errors.first("slug")
            }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-full w-full">
            <label class="vs-input--label"
              >{{ $t("Description") }} <span class="red">*</span></label
            >
            <!-- <b-textarea
              v-validate="'required'"
              v-model="departments.description"
              rows="4"
              :label="$t('Description')"
              name="description"
              :data-vv-as="$t('Description')"
              @keyup.enter.exact="checkForm"
              :placeholder="$t('Description')"
            /> -->
            <vue-editor v-model="departments.description" 
             v-validate="'required'"
            :editorOptions="editorSettings" 
            :label="$t('Description')"
            name="description"
            :data-vv-as="$t('Description')"
            @keyup.enter.exact="checkForm"
            :placeholder="$t('Description')"
            ></vue-editor>
            <span class="text-danger text-sm" v-show="errors.has('description')">{{
              errors.first("description")
            }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-full w-full">
            <label class="vs-input--label"
              >{{ $t("BookingMessage") }} <span class="red">*</span></label
            >
            <!-- <b-textarea
              v-model="departments.booking_message"
              v-validate="'required'"
              rows="4"
              :label="$t('BookingMessage')"
              name="booking_message"
              :data-vv-as="$t('BookingMessage')"
              @keyup.enter.exact="checkForm"
              :placeholder="$t('BookingMessage')"
            /> -->
             <vue-editor v-model="departments.booking_message" 
             v-validate="'required'"
            :data-vv-as="$t('BookingMessage')"
            :label="$t('BookingMessage')"
            :editorOptions="editorSettings"
            :placeholder="$t('BookingMessage')" 
            name="booking_message"
             @keyup.enter.exact="checkForm"
           ></vue-editor>
            <span class="text-danger text-sm" v-show="errors.has('booking_message')">{{
              errors.first("booking_message")
            }}</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col md:w-full w-full">
            <label class="vs-input--label"
              >{{ $t("AppointmentDuration1") }} <span class="red">*</span></label
            >
            <b-input
              size="lg"
              v-validate="'required|numeric'"
              autocomplete="off"
              name="duration"
              :data-vv-as="$t('AppointmentDuration')"
              v-model="departments.duration"
              class="w-full"
              @keydown.enter="checkForm"
              :placeholder="$t('AppointmentDuration')"
            />
            <span class="text-danger text-sm" v-show="errors.has('duration')">{{
              errors.first("duration")
            }}</span>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-3">
            <label class="vs-input--label"
              >{{ $t("Meeting") }} <span class="red">*</span></label
            >
            <v-select
              class="mt-1 w-full"
              :disabled="is_unio == 1 ? true : false"
              v-validate="{ required: this.departments.is_premium }"
              v-model="departments.is_premium"
              :options="options1"
              :reduce="(label) => label.value"
              label="label"
              name="is_premium"
              id="is_premium"
              :data-vv-as="$t('Meeting')"
              :placeholder="$t('SelectMeeting')"
              @input="is_check(departments.is_premium)"
              :clearable="false"
            >
              <template v-slot:option="option">
                <span :class="option.icon">{{ option.label }} </span>
                <feather-icon
                  v-if="departments.is_premium === option.value"
                  icon="CheckIcon"
                  class="float-right"
                  svgClasses="w-5 h-5"
                />
              </template>
            </v-select>

            <span class="text-danger text-sm" v-show="errors.has('is_premium')">{{
              errors.first("is_premium")
            }}</span>
          </div>
          <div class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-3">
            <label class="vs-input--label"
              >{{ $t("TypeOfMeeting") }} <span class="red">*</span></label
            >
            <v-select
              name="many_to_many"
              id="many_to_many"
              :disabled="is_unio == 1 ? true : false"
              v-validate="{ required: true }"
              class="mt-1 w-full"
              v-model="departments.many_to_many"
              :options="options2"
              :reduce="(label) => label.value"
              label="label"
              :data-vv-as="$t('TypeOfMeeting')"
              :placeholder="$t('TypeOfMeeting')"
              :clearable="false"
            >
              <template v-slot:option="option">
                <span :class="option.icon">{{ option.label }} </span>
                <feather-icon
                  v-if="departments.many_to_many === option.value"
                  icon="CheckIcon"
                  class="float-right"
                  svgClasses="w-5 h-5"
                />
              </template>
            </v-select>

            <span class="text-danger text-sm" v-show="errors.has('many_to_many')">{{
              errors.first("many_to_many")
            }}</span>
          </div>
        </div>
        <br />

        <!--  -->
        <div class="vx-row">
          <div class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2">
            <label class="vs-input--label">{{ $t("PreparationTime") }}</label>
            <div class="vx-row time">
              <div class="vx-col md:w-1/3 w-1/3">
                <b-input
                  v-validate="{
                    numeric: true,
                    min_value: this.timeMin,
                    max_value: this.timeMax,
                    max: 4,
                  }"
                  size="lg"
                  autocomplete="off"
                  name="time"
                  :data-vv-as="$t('PreparationTime')"
                  v-model="departments.preparation_time"
                  class="w-full"
                  @input="is_time"
                  @keydown.enter="checkForm"
                />
                <span class="text-danger text-sm" v-show="errors.has('time')">{{
                  errors.first("time")
                }}</span>
              </div>
              <div class="w-2/3">
                <v-select
                  class="pretype"
                  v-validate="{ required: false }"
                  v-model="departments.preparation_type"
                  :options="options3"
                  :reduce="(label) => label.value"
                  label="label"
                  name="is_type"
                  id="is_type"
                  :placeholder="$t('Hours')"
                  @input="is_type(departments.preparation_type)"
                  :clearable="false"
                >
                  <template v-slot:option="option">
                    <span :class="option.icon">{{ option.label }} </span>
                    <feather-icon
                      v-if="departments.preparation_type === option.value"
                      icon="CheckIcon"
                      class="float-right"
                      svgClasses="w-5 h-5"
                    />
                  </template>
                </v-select>
              </div>
              <!-- <span class="text-danger text-sm" v-show="errors.has('is_type')">{{
            errors.first("is_type")
          }}</span> -->
            </div>
          </div>
          <div
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-1"
            v-if="is_unio == 1"
          >
            <label class="vs-input--label">{{ $t("MaxPersonAppointment") }}</label>
            <b-input
              size="lg"
              v-validate="'numeric'"
              autocomplete="off"
              name="in_max_person_appointment"
              :data-vv-as="$t('MaxPersonAppointment')"
              v-model="departments.in_max_person_appointment"
              class="w-full"
              @keydown.enter="checkForm"
              :placeholder="$t('MaxPersonAppointment')"
            />
            <span
              class="text-danger text-sm"
              v-show="errors.has('in_max_person_appointment')"
              >{{ errors.first("in_max_person_appointment") }}</span
            >
          </div>
        </div>

        <!--  -->
        <div class="vx-row" id="app-container" v-if="departments.is_premium">
          <div class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-3">
            <label class="vs-input--label"
              >{{ $t("Amount") }} <span class="red">*</span></label
            >

            <b-input
              size="lg"
              v-model="departments.amount"
              v-validate="{
                required: this.departments.is_premium,
                regex: /^\d+(\.\d{1,2})?$/,
              }"
              autocomplete="off"
              name="amount"
              id="amount"
              :data-vv-as="$t('Amount')"
              class="w-full"
              @keydown.enter="checkForm"
              :placeholder="$t('Amount')"
            />
            <span class="text-danger text-sm" v-show="errors.has('amount')">{{
              errors.first("amount")
            }}</span>
          </div>

          <div class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-3">
            <label class="vs-input--label"
              >{{ $t("Currency") }} <span class="red">*</span></label
            >
            <v-select
              name="currency"
              id="currency"
              class="w-full"
              v-validate="{ required: this.departments.is_premium }"
              v-model="departments.currency"
              :options="options"
              size="large"
              :data-vv-as="$t('Currency')"
              :placeholder="$t('CurrencyPlaceholder')"
            >
              <template v-slot:option="option">
                <span :class="option.icon">{{ option.label }} </span>
                <feather-icon
                  v-if="departments.currency === option.label"
                  icon="CheckIcon"
                  class="float-right"
                  svgClasses="w-5 h-5"
                />
              </template>
            </v-select>

            <span class="text-danger text-sm" v-show="errors.has('currency')">{{
              errors.first("currency")
            }}</span>
          </div>
        </div>

          <div class="vx-row" v-if="departments.many_to_many == 0">
          <div class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-3">
            <label class="vs-input--label"
              >{{ $t("AllocationAlgorithm") }} <span class="red">*</span></label
            >
             <v-select
              name="is_random"
              id="is_random"
              class="w-full"
              v-validate="{ required: true }"
              v-model="departments.is_random"
              :options="options4"
              size="large"
              label="label"
              :reduce="(label) => label.value"
              :data-vv-as="$t('AllocationAlgorithm')"
              :placeholder="$t('AllocationAlgorithmPlaceholder')"
            >
              <template v-slot:option="option">
                <span :class="option.icon">{{ option.label }} </span>
                <feather-icon
                  v-if="departments.is_random === option.value"
                  icon="CheckIcon"
                  class="float-right"
                  svgClasses="w-5 h-5"
                />
              </template>
            </v-select>

             <span class="text-danger text-sm" v-show="errors.has('is_random')">{{
          errors.first("is_random")
        }}</span>
          </div>

          <div class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-3">
            <span v-if="departments.is_random == '1'"> {{ $t('RandomMessage') }}</span>
            <span v-if="departments.is_random == '0'"> {{ $t('OccupationRateMessage') }}</span>
          </div>
        </div>

        <div class="flex-container w-full" style="align-items: flex-start" v-if="false">
          <div>
            <b-form-checkbox
              v-model="departments.visiblity_status"
              size="lg"
              switch
              class="ml-1"
            >
            </b-form-checkbox>
          </div>
          <div>Automatic booking confirmation</div>
        </div>
        <div class="vx-row mb-4">
          <div
            class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-2"
            v-if="$route.params.id !== undefined"
          >
            <div class="flex walk-card">
              <b-form-checkbox
                v-model="departments.visiblity_status"
                size="lg"
                switch
                class="ml-1"
              >
              </b-form-checkbox>
              <span class="ml-4">{{ $t("Visiblity") }}</span>
            </div>
          </div>
          <template v-if="!is_unio">
            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-2"
            >
              <div class="flex items-center mb-4 walk-card">
                <b-form-checkbox
                  v-model="departments.automatic_booking_confirmation"
                  size="lg"
                  switch
                  class="ml-1"
                >
                </b-form-checkbox>
                <span class="ml-4">{{ $t("AutomaticBookingConfirmation") }}</span>
              </div>
            </div>
            <div
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-2"
            >
              <div class="flex items-center mb-4 walk-card">
                <b-form-checkbox
                  v-model="departments.is_physical_appointment"
                  size="lg"
                  switch
                  class="ml-1"
                >
                </b-form-checkbox>
                <span class="ml-4">{{ $t("IsPhysicalAppointment") }}</span>
              </div>
            </div>
            <div
              v-if="$store.getters.isChatEnabled"
              class="vx-col w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2 mt-2"
            >
              <div class="flex items-center mb-4 walk-card">
                <b-form-checkbox
                  v-model="departments.is_enable_chat"
                  size="lg"
                  switch
                  class="ml-1"
                >
                </b-form-checkbox>
                <span class="ml-4">{{ $t("IsEnableChat") }}</span>
              </div>
            </div>
          </template>
        </div>

        <div class="vx-col" id="update">
          <b-button
            variant="primary"
            v-if="this.$route.params.id"
            type="filled"
            @click.prevent="updateForm"
            class="mt-5 block"
            >{{ $t("Update") }}</b-button
          >
          <b-button
            v-else
            variant="primary"
            type="filled"
            @click.prevent="submitForm"
            class="mt-5 block"
            >{{ $t("Submit") }}</b-button
          >

          <router-link :to="'/company/department'">
            <b-button
              class="mt-5 br-20 pl-5 pr-5 border-primary text-primary"
              variant="border"
              id="cancel"
              type="border"
              >{{ $t("Cancel") }}</b-button
            >
          </router-link>
        </div>
      </form>
    </b-card>

    <b-card class="mt-5" v-if="this.$route.params.id && !recordNotFound">
      <h4 class="heading">
        {{ $t("Staffs") }}
        <feather-icon
          id="export"
          icon="DownloadCloudIcon"
          svgClasses="w-5 h-5 hover:text-danger stroke-current"
          class="ml-5"
          :title="$t('Export')"
          v-b-modal.modal-1
        />
      </h4>

      <b-modal
        id="modal-1"
        :title="$t('ExportToExcel')"
        :ok-title="$t('Export')"
        :cancel-title="$t('Cancel')"
        @ok="exportToExcel"
        @cancel="clearFields"
        @close="clearFields"
        class="export-options"
        centered
      >
        <b-input
          v-model="fileName"
          :placeholder="$t('FileName')"
          :label="$t('FileName')"
          class="w-full"
        />
        <v-select v-model="selectedFormat" :options="formats" class="my-4"
          ><template v-slot:option="option">
            <span :class="option.icon">{{ option.label }} </span>
            <feather-icon
              v-if="selectedFormat == option.label"
              icon="CheckIcon"
              class="float-right"
              svgClasses="w-5 h-5"
            />
          </template>
        </v-select>
        <div class="flex walk-card">
          <span class="mr-4">{{ $t("CellAutoWidth") }}:</span>
          <b-form-checkbox v-model="cellAutoWidth" size="lg" name="cell_width" switch>
          </b-form-checkbox>
        </div>
      </b-modal>

      <div class="export-table mt-5">
        <div class="w-1/2 mb-4">
          <b-button
            v-if="!departments.staff_user_id"
            class="br-20 float-left add btn-primary:focus"
            variant="primary"
            @click="openPopup"
            >{{ $t("Add") }}</b-button
          >
        </div>
        <b-col lg="5" class="w-1/2 float-right">
          <b-form-group
            label-for="filter-input"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            class="mb-5"
          >
            <b-input-group size="md">
              <b-input-group-prepend is-text>
                <b-icon icon="search"></b-icon>
              </b-input-group-prepend>
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                :placeholder="$t('Search')"
              ></b-form-input>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-table
          :current-page="currentPage"
          :per-page="perPage"
          :items="staffs"
          :fields="fields"
          :busy="isBusy"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-direction="sortDirection"
          responsive
          show-empty
          :filter="filter"
          :filter-included-fields="filterOn"
          :empty-text="$t('EmptyData')"
          :empty-filtered-text="$t('EmptyFilter')"
          @filtered="onFiltered"
        >
          <template #head()="data">
            <span>{{ $t(data.label) }}</span>
          </template>

          <template #cell(action)="row">
            <feather-icon
              v-b-tooltip.hover
              :title="$t('Edit')"
              icon="EditIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click="$router.push('/company/staff/update/' + row.item.id)"
            />
            <feather-icon
              v-b-tooltip.hover
              :title="$t('Show')"
              icon="EyeIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click="$router.push('/company/staff/show/' + row.item.id)"
            />
            <feather-icon
              v-if="!departments.staff_user_id"
              v-b-tooltip.hover
              :title="$t('RemoveStaff')"
              icon="XCircleIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click="removeStaff(row.item.id)"
            />
            <!-- <feather-icon
                v-if="is_unio == 1"
                v-b-tooltip.hover
                :title="$t('Update') + ' ' + $t('MaxNumberOfAppointment')"
                icon="CalendarIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click="openAddPopup(row.item)"
              /> -->
          </template>
        </b-table>

        <b-pagination
          v-if="totalRows > perPage"
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          aria-controls="my-table"
          class="float-right"
        ></b-pagination>
      </div>
    </b-card>

    <b-modal
      id="max-appointment-popup"
      :title="$t('AddStaffMember')"
      v-model="popupActivo"
      centered
      @ok="addStaffMember"
      ok-only
      :okTitle="$t('Add')"
      no-close-on-backdrop
    >
      <div class="mt-5 mb-5">
        <v-select
          multiple
          size="lg"
          v-model="staffIds"
          :options="staffOptions"
          :reduce="(staff_name) => staff_name.id"
          label="full_name"
          :placeholder="$t('SelectStaff')"
          v-validate="{ required: true }"
          name="staff"
          :data-vv-as="$t('AddStaff')"
        >
          <template v-slot:option="option">
            <span>{{ option.full_name }} </span>
            <feather-icon
              v-if="staffIds && staffIds.includes(option.id)"
              icon="CheckIcon"
              class="float-right"
              svgClasses="w-5 h-5"
            />
          </template>
        </v-select>
        <span class="text-danger text-sm" v-show="errors.has('staff')">{{
          errors.first("staff")
        }}</span>
      </div>
    </b-modal>
  </b-overlay>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";
import $ from "jquery";
// For custom error message
import { Validator } from "vee-validate";
import Vue from "vue";
import { getEditorSettings } from "@/utils/helper";

import { VueEditor, Quill } from "vue2-editor";
import Emoji from 'quill-emoji/dist/quill-emoji';
import "quill-emoji/dist/quill-emoji.css"; 

Quill.register({
'formats/emoji': Emoji.EmojiBlot,
'modules/short_name_emoji': Emoji.ShortNameEmoji,
'modules/toolbar_emoji': Emoji.ToolbarEmoji,
'modules/textarea_emoji': Emoji.TextAreaEmoji
},true);

export default {
  components: {
    FormWizard,
    TabContent,
    "v-select": vSelect,
    VueEditor
  },
  data() {
    return {
      editorSettings: getEditorSettings(),
      temp: [],
      company: "Select Company Name",
      options: [
        "USD",
        "AED",
        "AFN",
        "ALL",
        "AMD",
        "ANG",
        "AOA",
        "ARS",
        "AUD",
        "AWG",
        "AZN",
        "BAM",
        "BBD",
        "BDT",
        "BGN",
        "BIF",
        "BMD",
        "BND",
        "BOB",
        "BRL",
        "BSD",
        "BWP",
        "BZD",
        "CAD",
        "CDF",
        "CHF",
        "CLP",
        "CNY",
        "COP",
        "CRC",
        "CVE",
        "CZK",
        "DJF",
        "DKK",
        "DOP",
        "DZD",
        "EGP",
        "ETB",
        "EUR",
        "FJD",
        "FKP",
        "GBP",
        "GEL",
        "GIP",
        "GMD",
        "GNF",
        "GTQ",
        "GYD",
        "HKD",
        "HNL",
        "HRK",
        "HTG",
        "HUF",
        "IDR",
        "ILS",
        "INR",
        "ISK",
        "JMD",
        "JPY",
        "KES",
        "KGS",
        "KHR",
        "KMF",
        "KRW",
        "KYD",
        "KZT",
        "LAK",
        "LBP",
        "LKR",
        "LRD",
        "LSL",
        "MAD",
        "MDL",
        "MGA",
        "MKD",
        "MMK",
        "MNT",
        "MOP",
        "MRO",
        "MUR",
        "MVR",
        "MWK",
        "MXN",
        "MYR",
        "MZN",
        "NAD",
        "NGN",
        "NIO",
        "NOK",
        "NPR",
        "NZD",
        "PAB",
        "PEN",
        "PGK",
        "PHP",
        "PKR",
        "PLN",
        "PYG",
        "QAR",
        "RON",
        "RSD",
        "RUB",
        "RWF",
        "SAR",
        "SBD",
        "SCR",
        "SEK",
        "SGD",
        "SHP",
        "SLL",
        "SOS",
        "SRD",
        "STD",
        "SZL",
        "THB",
        "TJS",
        "TOP",
        "TRY",
        "TTD",
        "TWD",
        "TZS",
        "UAH",
        "UGX",
        "UYU",
        "UZS",
        "VND",
        "VUV",
        "WST",
        "XAF",
        "XCD",
        "XOF",
        "XPF",
        "YER",
        "ZAR",
        "ZMW",
      ],
      options1: [
        { label: this.$t("FreeMeeting"), value: false },
        { label: this.$t("PremiumMeeting"), value: true },
      ],

      options2: [
        { label: this.$t("OneToOne"), value: 0 },
        { label: this.$t("Conference"), value: 1 },
        { label: this.$t("Webinar"), value: 2 },
      ],
      options3: [
        { label: this.$t("Hours"), value: "hours" },
        { label: this.$t("Days"), value: "days" },
        { label: this.$t("Minutes"), value: "minutes" },
      ],

       options4: [
        { label: this.$t("OccupationRate"), value: 0 },
        { label: this.$t("Random"), value: 1 },
      ],

      departments: {
        company_id: "",
        department_name: "",
        description: "",
        booking_message: "",
        duration: "",
        amount: "",
        currency: "",
        many_to_many: 0,
        slug: "",
        is_premium: false,
        automatic_booking_confirmation: false,
        preparation_time: 0,
        preparation_type: "hours",
        in_max_person_appointment: "",
        is_enable_chat: false,
        is_physical_appointment: false,
        visiblity_status: false,
        is_random: 0
      },
      enable_header_footer: 1,
      is_edit: false,
      time: 0,
      timeMin: 0,
      timeMax: 48,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,

      fileName: "",
      formats: ["xlsx", "csv", "txt"],
      cellAutoWidth: true,
      selectedFormat: "xlsx",
      headerTitle: ["FirstName", "LastName", "Email", "Number", "Department"],
      headerVal: [
        "first_name",
        "last_name",
        "email",
        "contact_number",
        "department_names",
      ],
      staffs: [],
      perPage: 10,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      isBusy: false,
      fields: [
        {
          key: "first_name",
          label: "FirstName",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "last_name",
          label: "LastName",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "email",
          label: "Email",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "department_names",
          label: "Department",
          sortable: true,
          sortDirection: "desc",
        },
        { key: "action", label: "Action" },
      ],
      popupActivo: false,
      staffIds: [],
      staffOptions: [],
      //added on 11/02/2022
      directUrl: "",
      totalRows: 1,
      recordNotFound: false
    };
  },

  computed: {
    is_unio() {
      return this.$store.getters.currentUser.is_unio;
    },
    rows() {
      return this.staffs.length;
    },
  },
  watch: {
    enable_header_footer(value) {
      value == false ? (value = 0) : (value = 1);
      return value;
    },
    "$i18n.locale": {
      handler: function (value) {
        this.options1 = [
          { label: this.$t("FreeMeeting"), value: false },
          { label: this.$t("PremiumMeeting"), value: true },
        ];

        this.options2 = [
          { label: this.$t("OneToOne"), value: 0 },
          { label: this.$t("Conference"), value: 1 },
        ];

        this.options3 = [
          { label: this.$t("Hours"), value: "hours" },
          { label: this.$t("Days"), value: "days" },
          { label: this.$t("Minutes"), value: "minutes" },
        ];

        if (!this.$route.params.id) {
          $(".vs__selected")[0].innerText = this.$t("FreeMeeting");
          $(".vs__selected")[1].innerText = this.$t("OneToOne");
        }
        this.loadLocale(value);
      },
    },
  },
  created() {
    if (this.$route.params.id) {
      this.getDepartment(this.$route.params.id);
      this.getStaffs();
    }
    this.loadLocale(this.$i18n.locale);
  },

  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    /**
     * copy code method added on 11/02/2022
     */
    copyCode(url) {
      this.$copyText(url).then(
        (e) => {
          this.$toasted.show(this.$t("CopyText"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        },
        function (e) {
          this.$toasted.show(this.$t("CopyTextError"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        }
      );
    },
    is_check(value) {
      if (value == false) {
        this.departments.amount = "";
        this.departments.currency = "";
      }
    },
    /**
     * vee validate with Prepration type
     */

    is_type(value) {
      if (value == "minutes") this.timeMax = 1440;
      else if (value == "days") this.timeMax = 365;
      else this.timeMax = 48;
    },
    /**
     * vee validate with Prepration time
     */

    is_time(value) {
      this.departments.preparation_time = value.replace(/^0+(?=\d)/, "");
    },
    /**
     * vee validate with multi lang
     */

    changeSlug(value) {
      this.departments.slug = value.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
    },
    /**
     * vee validate with multi lang
     */

    editSlug(value) {
      this.departments.slug = value.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
    },
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    /**
     *  checkForm method for check form
     **/
    checkForm() {
      if (this.$route.params.id) {
        this.updateForm();
      } else {
        this.submitForm();
      }
    },
    /**
     *  updateForm method for updating values of form
     **/

    updateForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateDepartment();
        }
      });
    },
    /**
     *  getDepartment method get department data
     **/
    getDepartment(id) {
      this.show = true;

      this.$store
        .dispatch("ShowDepartment", id)
        .then((res) => {
          this.show = false;
          this.departments = res.data.data;
          this.directUrl = this.departments.department_url || null;
          this.departments.visiblity_status = this.departments.visiblity_status == 1;
          this.departments.automatic_booking_confirmation =
            this.departments.automatic_booking_confirmation == 1;
          this.departments.is_physical_appointment =
            this.departments.is_physical_appointment == 1;

          this.departments.is_enable_chat =
            this.departments.is_enable_chat == 1 ? true : false;
          this.departments.is_physical_appointment = this.departments
            .is_physical_appointment
            ? true
            : false;

          this.is_type(this.departments.preparation_type);
          this.departments.is_premium = this.departments.is_premium ? true : false;
          this.departments.preparation_time =
            this.departments.preparation_time == ""
              ? 0
              : this.departments.preparation_time;
        })
        .catch((error) => {
          this.$log.error(
            "File : List.vue | Function : getDepartment() | Error :",
            error
          );
          this.show = false;
           if(error == "record_not_found"){
            this.recordNotFound = true
            return false;
          }
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     *  submitForm method for submiting form
     **/
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.addDepartments();
        }
      });
    },
    /**
     *  addDepartments method for add record in a department list
     **/
    addDepartments() {
      this.show = true;
      this.departments.company_id =
        this.$store.getters.roles == "assistant"
          ? this.$store.getters.currentUser.company_id
          : this.$store.getters.currentUser.id;
      if (this.$store.getters.currentUser.is_unio) {
        this.departments.automatic_booking_confirmation = 0;
        this.departments.is_enable_chat = 0;
      }

      this.departments.preparation_time =
        this.departments.preparation_time == "" ? 0 : this.departments.preparation_time;
      this.$store
        .dispatch("AddDepartment", this.departments)
        .then((res) => {
          this.show = false;
          this.temp = res.data.data;
          let is_address_available = this.temp.is_address_available;

          if (!is_address_available && this.departments.is_physical_appointment)
            this.$router.push({ path: "/company/settings/address" });
          else this.$router.push({ path: "/company/department" });

          this.$toasted.show(this.$t("DepartmentAdded"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : Form.vue | Function : addDepartments() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },
    /**
     *      updateDepartment method for update record in a department list
     **/

    updateDepartment() {
      this.show = true;
      this.departments.id = this.$route.params.id;

      if (this.$store.getters.currentUser.is_unio) {
        this.departments.automatic_booking_confirmation = 0;
        this.departments.is_enable_chat = 0;
      }

      this.$store
        .dispatch("UpdateDepartment", this.departments)
        .then((res) => {
          this.show = false;
          this.temp = res.data.data;
          let is_address_available = this.temp.is_address_available;
          if (!is_address_available && this.departments.is_physical_appointment)
            this.$router.push({ path: "/company/settings/address" });
          else this.$router.push({ path: "/company/department" });
          this.$toasted.show(this.$t("DepartmentUpdated"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            "File : Form.vue | Function : updateDepartment() | Error :",
            error
          );
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    /**
     *  exportToExcel method for export file according to format
     **/
    exportToExcel() {
      import("@/assets/utils/export").then((excel) => {
        const list = this.staffs;
        this.headerTitle.map((title, index) => {
          this.headerTitle[index] = this.$t(title);
        });

        const data = this.formatJson(this.headerVal, list);
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat,
        });
        this.headerTitle = ["FirstName", "LastName", "Email", "Number", "Department"];
        this.clearFields();
      });
    },
    /**
     *  @params filterVal ,jsonData
     * formatJson   method  for export file according to format
     **/
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
    /**
     *
     * clearFields   method  for export selected format
     **/
    clearFields() {
      this.fileName = "";
      this.cellAutoWidth = true;
      this.selectedFormat = "xlsx";
    },

    /**
     *
     * getStaffs   method  for list all staffs data
     **/
    getStaffs() {
      this.show = true;
      let data = {
        department_id: this.$route.params.id,
        company_id:
          this.$store.getters.roles == "assistant"
            ? this.$store.getters.currentUser.company_id
            : this.$store.getters.currentUser.id,
        is_option_listing: 0,
      };
      this.$store
        .dispatch("GetStaffByDepartmentId", data)
        .then((res) => {
          this.show = false;
          this.staffs = res.data.data;
          this.totalRows = this.staffs.length;
        })
        .catch((error) => {
          this.$log.error("File : List.vue | Function : getstaffs() | Error :", error);
          this.show = false;
          // Error response

          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });

          return false;
        });
    },

    removeStaff(staff_id) {
      this.$swal({
        title: this.$t("RemoveStaffMessage"),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then((result) => {
        if (result.value) {
          this.show = true;
          let data = {
            department_id: this.$route.params.id,
            staff_id: staff_id,
          };
          this.$store
            .dispatch("RemoveStaffFromDepartment", data)
            .then((res) => {
              this.show = false;
              this.getStaffs();
            })
            .catch((error) => {
              this.$log.error(
                "File : List.vue | Function : getstaffs() | Error :",
                error
              );
              this.show = false;
              // Error response

              this.error =
                this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
                  ? this.$t(error.replace(/[\s\/]/g, ""))
                  : error;
              this.$toasted.show(this.error, {
                className: "top-alert",
                position: "top-center",
                type: "error",
                duration: 2000,
              });

              return false;
            });
        }
      });
    },

    getNonDepartmentStaff() {
      this.show = true;
      let data = {
        department_id: this.$route.params.id,
        company_id:
          this.$store.getters.roles == "assistant"
            ? this.$store.getters.currentUser.company_id
            : this.$store.getters.currentUser.id,
        is_option_listing: 1,
      };
      //GetNonDepartmentStaff
      this.$store
        .dispatch("GetStaffByDepartmentId", data)
        .then((res) => {
          this.show = false;
          this.staffOptions = res.data.data;
        })
        .catch((error) => {
          this.$log.error("File : List.vue | Function : getstaffs() | Error :", error);
          this.show = false;
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });

          return false;
        });
    },

    openPopup() {
      this.getNonDepartmentStaff();
      this.popupActivo = true;
      this.staffIds = [];
    },

    addStaffMember(bvModalEvt) {
      bvModalEvt.preventDefault();
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.show = true;
          let data = {
            department_id: this.$route.params.id,
            staff_ids: this.staffIds,
          };
          //Add staff member
          this.$store
            .dispatch("AddStaffMember", data)
            .then((res) => {
              this.show = false;
              this.staffIds = [];
              this.getStaffs();
              this.popupActivo = false;
            })
            .catch((error) => {
              this.$log.error(
                "File : List.vue | Function : getstaffs() | Error :",
                error
              );
              this.show = false;
              // Error response
              this.error =
                this.$t(error.replace(/[\s\/]/g, "")) !== error.replace(/[\s\/]/g, "")
                  ? this.$t(error.replace(/[\s\/]/g, ""))
                  : error;
              this.$toasted.show(this.error, {
                className: "top-alert",
                position: "top-center",
                type: "error",
                duration: 2000,
              });

              return false;
            });
        }
      });
    },
  },
};
</script>
<style>
.vs-input--label {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
}
#update {
  display: inline-flex;
}

#cancel {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
}

.vx-row {
  margin-top: 20px;
}
.displayBlock {
  display: block;
}
.time {
  margin-top: 5px;
}
.pretype {
  width: 96%;
}

.v-select .vs__dropdown-toggle {
  height: auto;
  max-height: 100px;
}
#time-prepare {
  padding: 20px;
}

#department-form .form-control-lg {
  padding: 1.5rem 1rem;
  border-radius: 0.3rem;
}
.direct {
  display: flex;
}
</style>
